import { useContext } from 'react';

import { AppContext } from '.';

export const useAppStore = () => {
  return useContext(AppContext);
};
